import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { ActivityConfirmation } from 'src/app/_model/activity-confirmation';

/**
 * Interface Definition for an ActivityConfirmationsDaoService
 *
 * ACs are always backend-owned, so there is only one table and no local-only
 * variant: they arrive either from the sync or from the `acdto` key of a dynform
 * upload response, both times as a complete, authoritative record. Writes are
 * INSERT OR REPLACE keyed by the acid, so both paths can write the same AC.
 */
@Injectable()
export abstract class ActivityConfirmationsDaoService implements Resetable {
  public abstract saveActivityConfirmations(entries: ActivityConfirmation[]): Promise<void>;
  public abstract getActivityConfirmations(): Promise<ActivityConfirmation[]>;
  public abstract updateFilledFormData(acId: number, filledFormData: string): Promise<void>;

  /**
   * Rewrites the draft ownership of a single AC version to "this employee on this
   * device". Used by the takeover, which has to make the change visible before the
   * backend has confirmed it - the next sync overwrites the row either way.
   *
   * `draftownerservicejobid` is nulled rather than left alone: employee and service job
   * ownership are mutually exclusive, see ActivityConfirmation.draftOwnerEmpId.
   */
  public abstract updateDraftOwner(
    acId: number,
    draftOwnerEmpId: number,
    draftOwnerMcId: number,
  ): Promise<void>;

  // Resetable
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
